<!-- Display do resumo -->

<!-- VAZIO -->
<div *ngIf="!selectedSign">
  <div class="container display-sign empty"></div>
</div>
<!-- VAZIO -->

<div class="display-body" *ngIf="selectedSign">
  <!-- PENDÊNCIA -->
  <div class="d-flex align-items-center justify-content-between">
    <!-- TIPO SINALIZAÇÃO -->
    <div class="type-box">
      <p class="type-text">{{ selectedSign?.type | enumText: 'SignalingType' }}</p>
    </div>
    <!-- TIPO SINALIZAÇÃO -->

    <!-- BOTÕES -->
    <div class="d-flex">
      <a [routerLink]="
          selectedSign.type == signTypeEnum.Vertical
            ? '/catalog/sign-register/edit/' + selectedSign.groupId
            : '/catalog/sign-register/edit/' + selectedSign.id
        " [queryParams]="{ type: selectedSign.type }">
        <button class="btn btn-outline-primary d-flex justify-content-center align-items-center p-4 mr-3 ml-3"
          style="height: 32px; font-size: 20px">
          EDITAR
        </button>
      </a>
      <button class="btn btn-primary d-flex justify-content-center align-items-center p-4 mr-4 ml-3"
        [disabled]="loadingMasterFile"
        (click)="onConfirm(pendingStatusEnum.Approved)" style="height: 32px; font-size: 20px">
        CONFIRMAR
      </button>
    </div>
    <!-- BOTÕES -->
  </div>
  <!-- PENDÊNCIA -->

  <!-- INFO BOX 1 -->
  <div class="mt-3 info-box">
    <div class="d-flex align-items-center">
      <div class="row m-0 align-items-center position-relative">
        <!-- SVG H&D -->
        <div *ngIf="!selectedSign.complementInformationType"
          [ngClass]="selectedSign.signCode | enumCaption: 'Caption':40" style="bottom: 6px"
          class="position-relative internal-caption mr-3">
          <span>{{
            selectedSign?.verticalType == verticalSignTypeEnum.Indication ? '' : selectedSign.internalCaption
            }}</span>
          <img [src]="selectedSign.signCode | enumSvg: 'Signaling' : selectedSign.type : selectedSign.color"
            [ngClass]="{'sign-cam-40': selectedSign?.signCode == verticalSignEnum.ViaFiscalizadaPorCameras}"
            style="width: 40px; object-fit: contain; height: 40px" />

        </div>
        <!-- SVG H&D -->

        <!-- SVG VERTICAL -->
        <div *ngIf="selectedSign.type == signTypeEnum.Vertical && selectedSign.complementInformationType"
          class="d-flex justify-content-center mr-3" style="height: 60px; width: 40px">
          <img *ngIf="selectedSign.complementInformationType == complementInformationTypeEnum.Additional"
            [src]="complementType(selectedSign) | enumSvg: 'ComplementInformation'"
            style="width: 40px; height: 20px; position: absolute; object-fit: contain; bottom: 8px" />
          <img *ngIf="selectedSign.complementInformationType == complementInformationTypeEnum.Incorporated"
            [src]="complementType(selectedSign) | enumSvg: 'ComplementInformation'"
            style="width: 40px; height: 60px; position: absolute; object-fit: contain; bottom: 8px" />
          <div [ngClass]="selectedSign.signCode | enumCaption: 'Caption':32" class="position-relative internal-caption"
            style="height: 32px; width: 32px">
            <span class="position-absolute" style="z-index: 1">{{
              selectedSign?.verticalType == verticalSignTypeEnum.Indication ? '' : selectedSign.internalCaption
              }}</span>
            <img [src]="selectedSign.signCode | enumSvg: 'Signaling' : selectedSign.type : selectedSign.color"
              style="width: 32px; height: 32px; object-fit: contain; position: absolute" />

          </div>
        </div>
        <!-- SVG VERTICAL -->

        <!-- COMBINADA VERTICAL -->
        <div *ngIf="selectedSign?.combined" class="mb-3 row mx-3 m-0 align-items-center pr-2"
          style="background-color: var(--snow-dark); border-radius: 8px">
          <i class="fas fa-link m-2 icon-sign-link"></i>
          <img *ngFor="let item of selectedSign?.combinedSign; let i = index" [src]="item.svg"
            [ngClass]="{ 'mr-2': i == 0 }" style="width: 24px; height: 24px"
            (click)="signDetailRouting(selectedSign?.groupId, item.order)" />
        </div>
        <!-- COMBINADA VERTICAL -->
      </div>

      <!-- NOME SINALIZACAO -->
      <div class="d-flex flex-column ml-3" style="max-width: 280px">
        <h4 style="color: var(--gray-base)">Nome da Sinalização</h4>
        <span>{{ selectedSign?.signCode | enumText: 'Signaling' }}</span>
      </div>
      <!-- NOME SINALIZACAO -->
    </div>

    <hr class="m-0" style="width: 100%; height: 1px" />

    <div class="d-flex flex-column" style="gap: 16px">
      <!-- CADASTRO E RESPONSÁVEL -->
      <div class="d-flex">
        <div class="d-flex flex-column col-6 p-0">
          <h4 style="color: var(--gray-base)">Data de Cadastramento</h4>
          <span>{{ selectedSign?.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="d-flex flex-column col-6 p-0">
          <h4 class="text-muted">Responsável</h4>
          <span>{{
            selectedSign.userCreator ||
            selectedSign?.responsibleMember?.user?.firstName + ' ' + selectedSign?.responsibleMember?.user?.lastName
            }}</span>
        </div>
      </div>
      <!-- CADASTRO E RESPONSÁVEL -->

      <!-- VÍNCULOS -->
      <div class="d-flex">
        <div class="d-flex flex-column col-6 p-0">
          <h4 style="color: var(--gray-base)">Vínculo</h4>
          <span>{{ selectedSign?.contract?.name ? selectedSign?.contract.name : 'Sem vínculo contratual' }}</span>
        </div>
        <div class="d-flex flex-column col-6 p-0">
          <h4 style="color: var(--gray-base)">Vínculo Secundário</h4>
          <span>{{ selectedSign?.project?.name ? selectedSign?.project?.name : 'Sem vínculo projetual' }}</span>
        </div>
      </div>
      <!-- VÍNCULOS -->

      <!-- GARANTIA -->
      <div class="d-flex">
        <div class="d-flex flex-column">
          <h4 style="color: var(--gray-base)">Garantia</h4>
          <span>{{
            dateService.getTextDate(selectedSign?.warrantyCurrent) == 0
            ? 'Fim da Garantia'
            : dateService.getTextDate(selectedSign?.warrantyCurrent) +
            ' (expira em ' +
            (selectedSign?.warranty | date: 'dd/MM/yyyy') +
            ')'
            }}</span>
        </div>
      </div>
      <!-- GARANTIA -->

      <!-- CUSTO -->
      <div class="invested-amount">
        <span> {{ selectedSign?.type == signTypeEnum.Vertical ? 'Valor da Placa' : 'Valor Investido' }} </span>
        <span class="money-text">{{ selectedSign?.cost | currency:'BRL':'R$' }}</span>
      </div>

      <div class="invested-amount" *ngIf="selectedSign?.type == signTypeEnum.Vertical">
        <span> Valor do Suporte </span>
        <span class="money-text">{{ selectedSign?.supportCost | currency:'BRL':'R$' }}</span>
      </div>

      <div class="invested-amount" *ngIf="selectedSign?.type == signTypeEnum.Vertical && shouldDisplayAuxiliarGroup()">
        <span> Valor do Item Auxliliar </span>
        <span class="money-text">{{ selectedSign?.auxiliarItemsCost | currency:'BRL':'R$' }}</span>
      </div>
      <!-- CUSTO -->
    </div>
  </div>
  <!-- INFO BOX 1 -->

  <!-- INFO BOX 2 -->
  <div class="mt-4 info-box">
    <div class="d-flex flex-column" style="gap: 16px">
      <!-- LOCALIZAÇÃO -->
      <div class="d-flex">
        <div class="d-flex flex-column">
          <h4 style="color: var(--gray-base)">Localização</h4>
          <span>{{
            (selectedSign.address?.road ? selectedSign.address?.road + ', ' : '') +
            (selectedSign.address?.road
            ? selectedSign.address?.house_number
            ? selectedSign.address?.house_number + ' - '
            : 's/ nº - '
            : '') +
            (selectedSign.address?.suburb ? selectedSign.address?.suburb + ', ' : '') +
            (selectedSign.address?.city ? selectedSign.address?.city : '') +
            (selectedSign.address?.postcode ? ', ' + selectedSign.address?.postcode : '')
            }}</span>
        </div>
      </div>
      <!-- LOCALIZAÇÃO -->

      <!-- REGIÃO E ÁREA -->
      <div class="d-flex">
        <div class="d-flex flex-column col-6 p-0">
          <h4 style="color: var(--gray-base)">Região</h4>
          <span>{{ selectedSign?.regions?.length > 0 ? selectedSign?.regions[0].name : '-' }}</span>
        </div>
        <div class="d-flex flex-column col-6 p-0">
          <h4 style="color: var(--gray-base)">Área</h4>
          <span>{{ selectedSign?.areas?.length > 0 ? selectedSign?.areas[0].name : '-' }}</span>
        </div>
      </div>
      <!-- REGIÃO E ÁREA -->

      <!-- TRAJETO - HORIZONTAL -->
      <ng-container *ngIf="selectedSign?.type == signTypeEnum.Horizontal">
        <div class="d-flex flex-column">
          <h4 style="color: var(--gray-base)">Trajeto</h4>
          <span>{{ selectedSign?.path?.name ? selectedSign?.path?.name : '-' }}</span>
        </div>
      </ng-container>
      <!-- TRAJETO - HORIZONTAL -->
    </div>
  </div>

  <!-- INFO BOX 2 -->

  <!-- INFO BOX 3 -->
  <div *ngIf="selectedSign?.contractSignItemId || selectedSign?.contractSupportItemId" class="mt-4 info-box">
    <!-- HVD -->
    <div class="d-flex">
      <!-- BOX NUMBER -->
      <div *ngIf="selectedSign?.contractSignItem?.id" class="item-number">
        <p class="m-0 text-primary">{{ selectedSign?.itemContractNumber }}</p>
      </div>
      <!-- BOX NUMBER -->

      <div class="col-9">
        <!-- NOME DO ITEM -->
        <ng-container *ngIf="selectedSign?.contractSignItem?.id">
          <h4 class="mb-2" style="color: var(--gray-base)">Nome do Item</h4>
          <p class="mb-3">{{ selectedSign?.contractSignItem?.name || '-' }}</p>
        </ng-container>
        <!-- NOME DO ITEM -->

        <!-- INFORMAÇÕES VERTICAL -->
        <ng-container *ngIf="selectedSign?.type == signTypeEnum.Vertical">
          <h4 class="mb-2" style="color: var(--gray-base)">Tipo do Substrato</h4>
          <p class="mb-3">{{ selectedSign.roadSignSubstrateTranslate || '-' }}</p>

          <h4 class="mb-2" style="color: var(--gray-base)">Tipo da Película</h4>
          <p class="mb-3">{{ selectedSign.roadSignFilm?.name || '-' }}</p>

          <h4 class="mb-2" style="color: var(--gray-base)">Tipo da Informação Complementar</h4>
          <p class="mb-3">
            {{
            selectedSign.complementInformationType
            ? (selectedSign.complementInformationType | enumText: 'ComplementInformation')
            : '-'
            }}
          </p>

          <h4 class="mb-2" style="color: var(--gray-base)">Informação Complementar</h4>
          <p class="mb-3">{{ selectedSign.complementInformation || '-' }}</p>
        </ng-container>
        <!-- INFORMAÇÕES VERTICAL -->

        <!-- INFORMAÇÕES HORIZONTAL -->
        <ng-container *ngIf="selectedSign?.type == signTypeEnum.Horizontal">
          <h4 class="mb-2" style="color: var(--gray-base)">Material Aplicado</h4>
          <p class="mb-3">{{ selectedSign.roadSignMarkingPaint?.name || '-' }}</p>
        </ng-container>
        <!-- INFORMAÇÕES HORIZONTAL -->

        <ng-container *ngIf="selectedSign?.type != signTypeEnum.Device">
          <h4 class="mb-2" style="color: var(--gray-base)">Dimensões</h4>

          <div class="d-flex mb-2">
            <div class="type-box" style="background-color: var(--snow-dark)">
              <p class="type-text" style="color: var(--gray-dark)">{{ selectedSign?.dimensionType }}</p>
            </div>
            <ng-container *ngIf="
                selectedSign?.type == signTypeEnum.Vertical &&
                !(selectedSign.signCode == verticalSignEnum.R1 || selectedSign.signCode == verticalSignEnum.R2) &&
                selectedSign?.dimensionType == dimensionTypeEnum.Efetiva
              ">
              <ng-container *ngIf="selectedSign.verticalType == verticalSignTypeEnum.Regulation; else elseDiameter">
                <span class="mr-2 text-primary">Ø</span>
                <span class="mr-3">
                  {{ selectedSign.diameter ? stringToFloatFixed(selectedSign.diameter) + ' m' : '-' }}</span>
              </ng-container>
              <ng-template #elseDiameter>
                <i class="mr-2 fa-regular text-primary fa-arrows-v"></i>
                <span class="mr-3">{{
                  selectedSign.sideLength ? stringToFloatFixed(selectedSign.sideLength) + ' m' : '-'
                  }}</span>
              </ng-template>
            </ng-container>
            <ng-container *ngIf="
                selectedSign?.type == signTypeEnum.Horizontal &&
                selectedSign?.dimensionType == dimensionTypeEnum.Efetiva
              ">
              <i class="mr-2 fa-regular fa-bring-forward text-primary"></i>
              <span class="mr-3">{{ stringToFloatFixed(selectedSign.quantity) }}</span>
            </ng-container>
            <ng-container *ngIf="
                selectedSign?.dimensionType == dimensionTypeEnum.Envolvente ||
                selectedSign?.type == signTypeEnum.Horizontal ||
                selectedSign.signCode == verticalSignEnum.R1 ||
                selectedSign.signCode == verticalSignEnum.R2
              ">
              <i class="mr-2 fa-regular text-primary fa-arrows-v"></i>
              <span class="mr-3">
                {{ selectedSign.dimensionY ? stringToFloatFixed(selectedSign.dimensionY) + ' m' : '-' }}</span>
              <ng-container
                *ngIf="!(selectedSign.signCode == verticalSignEnum.R1 || selectedSign.signCode == verticalSignEnum.R2)">
                <i class="mr-2 fa-regular text-primary fa-arrows-h"></i>
                <span class="mr-3">{{
                  selectedSign.dimensionX ? stringToFloatFixed(selectedSign.dimensionX) + ' m' : '-'
                  }}</span>
              </ng-container>
            </ng-container>
            <i class="mr-2 fa-regular text-primary fa-arrows"></i>
            <span>{{ selectedSign.dimension ? stringToFloatFixed(selectedSign.dimension) + ' m²' : '-' }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedSign?.type == signTypeEnum.Device">
          <h4 class="mb-2" style="color: var(--gray-base)">Nomenclatura do Dispositivo</h4>
          <p>{{ selectedSign?.signName }}</p>

          <h4 class="mb-2" style="color: var(--gray-base)">Aplicação</h4>
          <div class="d-flex align-items-center">
            <i class="mr-2 fa-regular fa-bring-forward text-primary"></i>
            <span>{{ selectedSign.units ? stringToFloatFixed(selectedSign.units) + ' und.' : '-' }}</span>
          </div>
        </ng-container>
      </div>
    </div>
    <!-- HVD -->

    <!-- Suporte -->
    <div *ngIf="selectedSign?.type == signTypeEnum.Vertical" class="d-flex">
      <div *ngIf="selectedSign?.contractSupportItemId" class="item-number">
        <p class="m-0 text-primary">{{ selectedSign?.signSupportContractNumber }}</p>
      </div>
      <div class="col-9">
        <ng-container *ngIf="selectedSign?.contractSupportItemId">
          <h4 class="mb-2" style="color: var(--gray-base)">Nome do item</h4>
          <p class="mb-3">{{ selectedSign?.contractSupportItem?.name }}</p>
        </ng-container>
        <h4 class="mb-2" style="color: var(--gray-base)">Tipo do Suporte</h4>
        <p class="mb-3">{{ selectedSign?.supportMaterialTranslate || '-' }}</p>
        <h4 class="mb-2" style="color: var(--gray-base)">Quantidade de Suportes</h4>
        <p class="mb-3">
          {{ selectedSign?.existingSupport ? '-' : selectedSign?.supportQuantity }}
        </p>
      </div>
    </div>

    <div *ngIf="selectedSign?.type == signTypeEnum.Vertical" class="d-flex flex-column">
      <div class="d-flex align-items-start">
        <div class="col-2 item-number">
          <p class="m-0 text-primary">Auxiliar</p>
        </div>
        <div class="col-9">
          <ng-container>
            <h4 class="mb-2" style="color: var(--gray-base)">Nome do item</h4>
            <p class="mb-3">
              {{ selectedSign?.auxiliarItems[0]?.contractAuxiliarItem?.name | slice:0:30 }}
              {{ (selectedSign?.auxiliarItems[0]?.contractAuxiliarItem?.name?.length > 30) ? '...' : '' }}
            </p>
          </ng-container>
          <h4 class="mb-2" style="color: var(--gray-base)">Quantidade</h4>
          <p class="mb-3">
            {{ selectedSign?.auxiliarItems[0]?.quantity }}
          </p>
        </div>
      </div>
      <div class="mt-3">
        <ng-container *ngFor="let auxiliarItem of selectedSign.auxiliarItems; let i = index">
          <div *ngIf="i > 0" class="d-flex offset-2">
            <div class="col-9">
              <ng-container>
                <h4 class="mb-2" style="color: var(--gray-base)">Nome do item</h4>
                <p class="mb-3">
                  {{ auxiliarItem?.contractAuxiliarItem?.name | slice:0:30 }}
                  {{ (auxiliarItem?.contractAuxiliarItem?.name?.length > 30) ? '...' : '' }}
                </p>
              </ng-container>
              <h4 class="mb-2" style="color: var(--gray-base)">Quantidade</h4>
              <p class="mb-3">
                {{ auxiliarItem?.quantity }}
              </p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <!-- Suporte -->

  <!-- INFO BOX 3 -->

  <div class="d-flex flex-column mt-4" *ngIf="imageExists()">
    <div class="d-flex flex-column">
      <div class="col-12 p-0"
        *ngFor="let situation of [imageSituationEnum.After, imageSituationEnum.Before]; let i = index"
        [ngClass]="{ 'mb-4': i == 0 }">
        <h3 class="mb-3" style="color: var(--gray-base); font-weight: 400">
          {{ i ? 'Foto da Sinalização' : 'Foto do Local' }}
        </h3>
        <div class="d-flex mt-2" style="overflow: auto">
          <div *ngFor="let file of getImageList(); index as indexImg">
            <ng-container *ngIf="
                (situation == imageSituationEnum.Before && file.situation == imageSituationEnum.Before) ||
                (situation == imageSituationEnum.After && file.situation == imageSituationEnum.After)
              ">
              <div class="box-img-list cursor-pointer" (click)="downloadFileSign(file.url)">
                <div *ngIf="file" class="position-relative img-box">
                  <img [src]="file.url" class="list-image-upload" />
                  <div class="size-file">
                    <h4 style="color: white; pointer-events: none">
                      {{ file.file.size / (1024 * 1024) | number: '1.2-2' }}MB
                    </h4>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <ng-container *ngIf="getImageEmpty(situation)">
            <div class="box-img-list"></div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- BOTÃO GERAR OCORRÊNCIA -->
  <a class="d-flex align-items-center justify-content-end mt-4 btn-popup" (click)="newOccurrence()"
    style="font-weight: 600; font-size: 14px; cursor: pointer" [ngClass]="{'disabled-a': selectedSign.type == signTypeEnum.Vertical ?
    signalingOccurrenceIdList.includes(selectedSign.verticalSignalingId) :
    signalingOccurrenceIdList.includes(selectedSign.id)}">
    CRIAR OCORRÊNCIA <i class="fas fa-angle-right mr-0 ml-1" style="font-size: 20px"></i>
  </a>
  <!-- BOTÃO GERAR OCORRÊNCIA -->

  <!-- BOTÃO PÁGINA DE DETALHES -->
  <a class="d-flex align-items-center justify-content-end mt-4 btn-popup" (click)="signDetailRouting(selectedSign)"
    style="font-weight: 600; font-size: 14px; cursor: pointer">
    VER SINALIZAÇÃO <i class="fas fa-angle-right mr-0 ml-1" style="font-size: 20px"></i>
  </a>
  <!-- BOTÃO PÁGINA DE DETALHES -->
</div>

<!-- Modal de nova ocorrência -->
<app-occurrence-creation-modal #occurrenceCreationModal></app-occurrence-creation-modal>

<!-- Modal de posicionamento no arquivo-mestre (aprovação) -->
<ng-template #masterFilePositionModal>
  <div class="modal-header">
    <h4 class="modal-title">Posicionar sinalização no arquivo-mestre</h4>
    <button type="button" class="close" aria-label="Fechar" (click)="closeMasterFileModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="text-muted mb-3">
      Clique sobre o arquivo-mestre para posicionar a sinalização. Este passo é opcional —
      você pode aprovar sem posicionar e ajustar depois na página do projeto.
    </p>
    <app-master-file
      *ngIf="projectMasterFile"
      [selectedFile]="projectMasterFile.url"
      [pdf]="projectMasterFile.isPdf"
      [projectId]="selectedSign?.projectId ?? selectedSign?.project?.id"
      [signType]="selectedSign?.type"
      [signSvg]="signSvg"
      [referenceMarkers]="referenceMarkers"
      [masterFile]="masterFileToSave"
      (saveFile)="receiveMasterFile($event)">
    </app-master-file>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="approveWithoutPosition()">
      Aprovar sem posicionar
    </button>
    <button type="button" class="btn btn-primary" (click)="confirmWithPosition()">
      Confirmar e aprovar
    </button>
  </div>
</ng-template>
<!-- /Modal de nova ocorrência -->